export { default } from "./CopyClipboard";
